export default "__VITE_ASSET__BS_0CVbP__"